<template>
    <div id="portfolio_wrapper">
        <div id="portfolio">

            <section style="overflow-x: hidden!important" class="stipple-bg">
                <b-container class="header d-md-flex flex-column justify-content-center">
                    <b-row>
                        <b-col md="7" class="pr-md-0">
                            <img src="/img/pride-and-joy.svg" alt="Pride and Joy" class="w-100 d-block max-w-500 h-auto fade-in-up-element" width="500" height="375">
                        </b-col>
                        <b-col md="5" class="d-flex flex-column justify-content-end ">
                            <p class="gotham-light mb-0 reveal-text  mt-md-0 mt-5">
                                <span class="gotham-bold ">
                                    Welcome to the 1063 Hall of Fame.
                                </span>
                                Here you'll find the most recent inductees, featuring some of our proudest and most prolific campaigns, branding studies, deliverables, and more. Feel free to browse around at your leisure, and don't forget to stop by the gift shop before you leave!
                            </p>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <!--  -->
            <section class="stipple-bg">
                <b-container>
                    <p class="gotham-book pt-70">PORTFOLIO/</p>
                    <!--  -->
                    <div class="position-relative">
                        
                        <b-row>
                            <b-col class="px-0" cols="4">
                                <div class="position-relative d-flex justify-content-center align-items-center">
                                    <img src="/img/portfolio/ga-golf.jpg" alt="Golf" class="w-100 d-block">
                                    <div class="lora-italic h1 text-white text-overlay">Golf</div>
                                </div>
                            </b-col>
                            <b-col class="px-0" cols="4">
                                <div class="position-relative d-flex justify-content-center align-items-center">
                                    <img src="/img/portfolio/ga-lake.jpg" alt="Golf" class="w-100 d-block">
                                    <div class="lora-italic h1 text-white text-overlay">Lake</div>
                                </div>
                            </b-col>
                            <b-col class="px-0" cols="4">
                                <div class="position-relative d-flex justify-content-center align-items-center">
                                    <img src="/img/portfolio/ga-trail.jpg" alt="Golf" class="w-100 d-block">
                                    <div class="lora-italic h1 text-white text-overlay">Trail</div>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="bottom-text-overlay">
                            <div class="gotham-book text-md-right">
                                <p class="h5 reveal-text">
                                    Oakville Distilled
                                    <br>
                                    to Perfection
                                </p>
                                <a href="https://oakpointe.ca/" 
                                target="_blank"
                                class="ga-btn-white gotham-book mb-0 mt-3 btn-black-mobile">I WANT TO SEE MORE</a>
                            </div>
                        </div>
                    </div>
                    
                    <b-row class="mt-70 px-md-5">
                        <b-col md="7" class="d-md-flex justify-content-between flex-column pr-md-5">
                            <div class="fade-in-up-element overflow-hidden max-h-369">
                                <img src="/img/portfolio/ga-portfolio-kingscalling.jpg" 
                                alt="Kings Calling" 
                                class="w-100 d-block plax-img object-fit-cover"
                                width="459">
                            </div>
                            <div class="gotham-book text-md-right">
                                <p class="h5 reveal-text mt-4">
                                    Elegance is Calling,
                                    <br>
                                    Shall We Tell Them You're in?
                                </p>
                                <nuxt-link to="/portfolio/kingscalling" class="ga-btn-black gotham-book mt-3">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>

                        <b-col md="5" class="d-md-flex flex-column">
                            <div class="fade-in-up-element overflow-hidden mt-md-0 mt-5">
                                <img src="/img/portfolio/ga-portfolio-southbay.jpg" 
                                alt="Southbay" 
                                class="w-100 d-block plax-img"
                                data-lag="0.2">
                            </div>
                            <div class="gotham-book text-md-right mt-4">
                                <p class="h5 reveal-text">
                                    Sittin' on the Dock
                                    <br>
                                    of the Bay
                                </p>
                                <a href="https://riversedgewasaga.ca/" 
                                target="_blank"
                                class="ga-btn-black gotham-book mb-0 mt-3">I WANT TO SEE MORE</a>
                            </div>
                        </b-col>

                    </b-row>

                    <b-row class="mt-70 px-md-5">

                        <b-col md="6" class="d-md-flex justify-content-between flex-column">
                            <div class="pr-md-5 fade-in-up-element overflow-hidden">
                                <img src="/img/underground-dance-centre.jpg" 
                                alt="The Underground Dance Centre" 
                                class="w-100 d-block plax-img"
                                width="492"
                                height="525" data-lag="0.25">
                            </div>
                            <div class="gotham-book mt-4">
                                <p class="h5 reveal-text">
                                    And 5, 6, 7, 8:
                                    <br>
                                    Welcome To Toronto's #1
                                    <br>
                                    Dance Studio!
                                </p>
                                <nuxt-link to="/portfolio/the-underground" class="ga-btn-black gotham-book mb-0 mt-3 d-inline-block">I WANT TO SEE MORE</nuxt-link>
                            </div>
                            <div class="gotham-book text-md-right mt-100 d-md-block d-none">
                                <p class="h5 reveal-text">
                                    When It Comes To Giving
                                    <br> 
                                    Back, DECO's The Sweetest
                                </p>
                                <nuxt-link to="/portfolio/deco-homes" class="ga-btn-black gotham-book mb-0 mt-3 d-inline-block">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                        <b-col md="6" class="d-md-flex flex-column justify-content-end">
                            <div class="mt-5 pl-md-5 fade-in-up-element">
                                <div class="overflow-hidden h-100">
                                    <img src="/img/deco-ice-cream.jpg" 
                                    alt="The DECO Ice Cream Truck" 
                                    class="w-100 d-block plax-img"
                                    width="492"
                                    height="703">
                                </div>
                                <img src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp fade-in-up-element"
                                width="280"
                                height="282">
                            </div>
                            <div class="gotham-book text-md-right mt-4 d-block d-md-none">
                                <p class="h5 reveal-text">
                                    When It Comes To Giving
                                    <br> 
                                    Back, DECO's The Sweetest
                                </p>
                                <nuxt-link to="/portfolio/deco-homes" class="ga-btn-black gotham-book mb-0 mt-3 d-inline-block">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <!--  -->
            <section class="stipple-bg pt-100">
                <div class="position-relative">
                    <img src="/img/portfolio/portfolio-sp-building.jpg" alt="Southport Building" width="2800" height="1282" class="h-auto d-block w-100">
                    <div class="gotham-book text-md-right midbanner-text top-left">
                        <p class="h5 reveal-text gotham-book">
                            Three Beloved Toronto Lifestyles 
                            <br>
                            In One Demanded Location
                        </p>
                        <nuxt-link to="/portfolio/southport" class="ga-btn-black gotham-book mb-0 mt-3 d-inline-block">I WANT TO SEE MORE</nuxt-link>
                    </div>
                </div>
                <b-container>
                    <b-row class="mt-100">
                        <b-col md="6" class="d-md-flex justify-content-between flex-column pr-md-4">
                            <div class="fade-in-up-element overflow-hidden">
                                <img src="/img/portfolio/cetana-lg-thumb.jpg" 
                                alt="Cetana" 
                                class="w-100 d-block plax-img object-fit-cover"
                                width="459">
                            </div>
                            <div class="gotham-book text-md-right">
                                <p class="h5 reveal-text mt-4">
                                    It's Good To
                                    <br>
                                    Be Green
                                </p>
                                <nuxt-link to="/portfolio/cetana" class="ga-btn-black gotham-book mt-3">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                        <b-col md="6" class="d-md-flex flex-column pl-md-4">
                            <div class="fade-in-up-element overflow-hidden mt-md-0 mt-5">
                                <img src="/img/life-meets-lifestyle.jpg" 
                                alt="WHERE LIFE MEETS LIFESTYLE" 
                                class="w-100 d-block plax-img"
                                width="459"
                                data-lag="0.2">
                            </div>
                            <div class="gotham-book text-md-right mt-4">
                                <p class="h5 reveal-text">
                                    Everything's Coming Up
                                    <br>
                                    Millhouse!
                                </p>
                                <nuxt-link to="/portfolio/millhouse" class="ga-btn-black gotham-book mb-0 mt-3">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-100">
                        <b-col md="12">
                            <div class="position-relative">
                                <img src="/img/homepage-video-placeholder.jpg" 
                                alt="Video" 
                                class="w-100 d-block"
                                width="1110" 
                                height="513">
                                <div class="video-text-overlay">
                                    <div class="gotham-book text-md-right">
                                        <p class="h5 reveal-text text-white">
                                            See The Vision That
                                            <br>
                                            Transformed Pickering
                                        </p>
                                        <nuxt-link to="/portfolio/vupoint" class="ga-btn-white gotham-book mb-0 mt-3">I WANT TO SEE MORE</nuxt-link>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="mt-70">
                        <b-col md="6" class="d-md-flex justify-content-between flex-column">
                            <div class="fade-in-up-element overflow-hidden">
                                <img src="/img/the-pier.jpg" 
                                alt="The Pier" 
                                class="w-100 d-block plax-img"
                                width="459"
                                height="507">
                            </div>
                            <div class="gotham-book text-md-right mt-md-5 mt-3 d-md-none d-block">
                                <p class="h5 reveal-text">
                                    Apologies @Toronto,
                                    <br>
                                    The Pier Is Here
                                </p>
                                <nuxt-link to="/portfolio/the-pier" class="ga-btn-black gotham-book mt-3">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                        <b-col md="6" class="d-md-flex flex-column justify-content-between">
                            <div class="gotham-book text-md-right mt-3 d-md-block d-none">
                                <nuxt-link to="/portfolio/stacked-pilates" class="ga-btn-black gotham-book mb-0 mt-3">I WANT TO SEE MORE</nuxt-link>
                                <p class="h5 reveal-text mt-md-4 mt-5">
                                    Stacks On Stacks On Stacks
                                    <br>
                                    For Stacked Pilates
                                </p>
                            </div>
                            <div class="fade-in-up-element overflow-hidden pl-md-5 mt-md-0 mt-5">
                                <img src="/img/portfolio/stacked-pilates-thumb.jpg" 
                                alt="Stacked Pilates" 
                                class="w-100 d-block plax-img" style="height: 110%"
                                width="459"
                                height="507"
                                data-lag="0.2">
                            </div>
                            <!-- Mobile -->
                            <div class="gotham-book text-md-right mt-3 d-md-none d-block">
                                <nuxt-link to="/portfolio/stacked-pilates" class="ga-btn-black gotham-book mb-0 mt-3">I WANT TO SEE MORE</nuxt-link>
                                <p class="h5 reveal-text mt-3">
                                    Stacks On Stacks On Stacks
                                    <br>
                                    For Stacked Pilates
                                </p>
                            </div>
                            <!--  -->
                        </b-col>
                        <b-col md="6">
                            <div class="gotham-book text-md-right mt-md-5 mt-3 d-md-block d-none">
                                <p class="h5 reveal-text">
                                    Apologies @Toronto,
                                    <br>
                                    The Pier Is Here
                                </p>
                                <nuxt-link to="/portfolio/the-pier" class="ga-btn-black gotham-book mt-3">I WANT TO SEE MORE</nuxt-link>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <section class="stipple-bg pt-100 conclusion">
                <div class="position-relative">
                    <img src="/img/portfolio/deco-interior.jpg" alt="Decorated room" width="3000" height="1396" class="h-auto d-block w-100">
                    <div class="gotham-book text-md-right mt-100 midbanner-text bottom-right">
                        <p class="h5 reveal-text text text-white-mobile-black">
                            Better than tabloids,
                            <br>
                            it actually has substance
                        </p>
                        <nuxt-link to="/interior-design" class="ga-btn-white black-btn-mobile gotham-book mb-0 mt-3 d-inline-block">I WANT TO SEE MORE</nuxt-link>
                    </div>
                </div>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    data() {
        return {
            scrollSmoother_portfolio: null,
            textAnimation_portfolio: null,
            fadeInUpElement_portfolio: null
        }
    },
    components: {
        WhatWeDo: () => import('@/components/WhatWeDo'),
        WhereWeDoIt: () => import('@/components/WhereWeDoIt'),
        Transition1063: () => import('@/components/Transition1063'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_portfolioPage();
            // 
            this.initImgElReveal_portfolioPage();
            this.initTextReveal_portfolioPage();
        }, 500)
    },
    methods: {
        initscrollSmoother_portfolioPage() {
            this.scrollSmoother_portfolio = ScrollSmoother.create({
                wrapper: '#portfolio_wrapper',
                content: "#portfolio",
                smooth: 5,
                effects: true
            });
            this.scrollSmoother_portfolio.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_portfolioPage() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_portfolio = this.fadeInUpElement_portfolio;
                fadeInUpElement_portfolio = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_portfolio.set(container, { autoAlpha: 1 });
                fadeInUpElement_portfolio.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_portfolioPage() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_portfolio = this.textAnimation_portfolio;
                textAnimation_portfolio = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words",
                    wordsClass: "words",
                });
                textAnimation_portfolio.set(container, { autoAlpha: 1 });
                textAnimation_portfolio.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_portfolio.kill();
        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#portfolio {
    .text-overlay {
        position: absolute;
    }
    .header {
        height: 100vh;
        min-height: 800px;

        @media screen and (max-width: 767px) {
            padding: 140px 15px;
            min-height: unset;
            height: auto;
        }
    }

    .midbanner-text {
        position: absolute;

        @media screen and (max-width: 767px) {
            position: relative;
        }
    }

    .top-left {
        top: 60px;
        left: 10vw;

        @media screen and (max-width: 767px) {
            top: 20px;
        }
    }

    .bottom-right {
        bottom: 60px;
        right: 10vw;

        @media screen and (max-width: 767px) {
            right: unset;
            left: 15px;
        }
    }

    .video-text-overlay {
        position: absolute;
        top: 30px;
        right: 30px;
    }

    .bottom-text-overlay {
        position: absolute;
        bottom: 30px;
        right: 30px;
        z-index: 1;
        color: #fff;

        @media screen and (max-width: 767px) {
            position: relative;
            color: #000;
            padding: 40px 30px 0;
        }
    }

    .btn-black-mobile {
        @media screen and (max-width: 767px) {
            border: 2px solid #000;
            color: #000;
        }
    }

    .ga-circular-stamp {
        position: absolute;
        left: -5px;
        top: -183px;
        width: 100%;
        max-width: 280px;
        z-index: 1;

        @media screen and (max-width: 767px) {
            display: none;
        }
    }

    .black-btn-mobile {
        @media screen and (max-width: 767px) {
            border: 2px solid #000;
            color: #000;
        }
    }

    .text-white-mobile-black {
        color: #fff;

        @media screen and (max-width: 767px) {
            color: #000;
        }
    }
}


</style>